/* @flow */
import * as React from 'react';
import idx from 'idx';
import groupBy from 'lodash/groupBy';
import { Query } from 'react-apollo';
import GET_ADMIN_INTEGRATIONS from 'admin/queries/getAdminIntegrations.gql';
import GET_ORG_UUID from 'admin/queries/getOrgUuid.gql';

type Props = {
  children: Function,
  fetchPolicy?: ?string,
  organizationUUID: string,
  parentId: string,
};

function queryAdminIntegrations(queryVariables, children, parentUUID) {
  return (<Query
    query={GET_ADMIN_INTEGRATIONS}
    variables={queryVariables}
    refetchQueries={[{ query: GET_ADMIN_INTEGRATIONS, variables: queryVariables }]}>
    {({ loading, error, data }) => {
      if (loading || error) {
        return null;
      }

      const integrations = groupBy(data.adminPossibleIntegrations, integration => integration.__typename);
      return children({
        adminIntegrations: integrations.AdminIntegration,
        partnerIntegrations: integrations.PartnerIntegration,
        parentUUID,
      });
    }}
  </Query>)
}

export default function AdminIntegrationsContainer(props: Props) {
  const { children, organizationUUID, parentId } = props;
  const queryVariables = { organizationUUID };

  if (parentId) { // if parent organization (district) exists, query for its UUID
    return (<Query
      query={GET_ORG_UUID}
      variables={{ orgId: Number(parentId) }}>
      {({ loading, error, data }) => {
        if (loading || error) {
          return null;
        }
        const parentUUID = idx(data, _ => _.organizations[0].uuid);
        return queryAdminIntegrations(queryVariables, children, parentUUID);
      }}
    </Query>);
  } else { // else this is is the district, or this is a school w/o district affiliation
    return queryAdminIntegrations(queryVariables, children, null);
  }
}